module.exports = __webpack_public_path__ + "img/Airbnb-ENhanced-Focus-Avoiding-Distractions.bf3f6ae0.jpg";